import React, { useEffect, useState } from 'react';

import { IMAGE_BASE_URL } from '@/const/url';

const SplashComponent = ({ onFinish }: { onFinish: () => void }) => {
  const [fadeOut, setFadeOut] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFadeOut(true), 800);

    const finishTimer = setTimeout(() => {
      onFinish();
    }, 1200);

    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(finishTimer);
    };
  }, [onFinish]);

  return (
    <div
      className={`flex flex-col items-center justify-center w-full h-screen bg-grey-0 z-[100] transition-opacity duration-500 ${
        fadeOut ? 'opacity-0' : 'opacity-100'
      }`}
    >
      <img src={`${IMAGE_BASE_URL}/logo_primary-10.png`} alt="직트럭 로고" className="w-[180px]" />
      <span className="font-semibold text-primary-10 mt-6 break-keep text-[18px]">화물차 직거래 수수료 0원</span>
    </div>
  );
};

export default SplashComponent;
